exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".MessageGallery {\n  text-align: center;\n  margin: 50px auto 0;\n  max-width: 220px; }\n  .MessageGallery__icon {\n    font-size: 200px !important;\n    color: #313131; }\n  .MessageGallery__text {\n    color: #727272 !important; }\n  .MessageGallery__button {\n    margin-top: 10px !important; }\n", ""]);

